import React from 'react';
import { css } from '@emotion/core';
import PlayButton from '@embed/components/common/PlayButton';
import { useTranslation } from '@embed/hooks/react-i18nextLazy';
import ThumbnailPicture from '../common/ThumbnailPicture';
import { LOGO_HEIGHT, LOGO_HEIGHT_DESKTOP, THUMBNAIL_SPACE } from './constants';
import ToggleButton from './ToggleButton';
const Expandables = (props) => {
    const { isExpanded, onClick, onMouseEnter, onToggleExpand, reverse, videos } = props;
    const { t } = useTranslation();
    const items = videos.map((video, index) => {
        var _a, _b;
        const animatedThumbUrl = (_b = (_a = video === null || video === void 0 ? void 0 : video.video_posters) === null || _a === void 0 ? void 0 : _a.find((poster) => poster.video_poster_type === 'animated')) === null || _b === void 0 ? void 0 : _b.url;
        let thumbSize = [LOGO_HEIGHT_DESKTOP, LOGO_HEIGHT_DESKTOP];
        if (animatedThumbUrl && video) {
            const ratio = video.width / video.height;
            if (ratio > 1) {
                // landscape
                thumbSize = [Math.round(thumbSize[0] * ratio), thumbSize[0]];
            }
            else {
                // portrait
                thumbSize = [thumbSize[0], Math.round(thumbSize[0] / ratio)];
            }
        }
        return (<div key={video.encoded_id} onClick={onClick({ video, index })} onMouseEnter={onMouseEnter({ video, index })} css={css `
          display: block;
          cursor: pointer;
          margin: 0 !important;
          padding: 0 !important;
          height: ${LOGO_HEIGHT_DESKTOP}px;
          width: ${LOGO_HEIGHT_DESKTOP}px;
        `}>
        <ThumbnailPicture src={animatedThumbUrl || (video === null || video === void 0 ? void 0 : video.thumbnail_url)} options={{
                size: thumbSize,
                quality: false,
            }} alt={(video === null || video === void 0 ? void 0 : video.caption) || ''}>
          {({ src }) => (<img loading="lazy" src={src} style={{
                    width: '100%',
                    height: '100%',
                }} css={css `
                background-color: rgba(0, 0, 0, 0.2);
                border-radius: 50%;
                box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
                height: 100%;
                margin: 0 !important;
                object-fit: cover;
                padding: 0 !important;
                width: 100%;
              `}/>)}
        </ThumbnailPicture>
        <PlayButton aria-label={t(`Play {{caption}}`, { caption: video === null || video === void 0 ? void 0 : video.caption })} onClick={onClick({ video, index })} style={{ width: 58, height: 58 }} hidePlayIcon={!!animatedThumbUrl}/>
      </div>);
    });
    return (<div className="cy-fcb-slider" css={css `
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: ${reverse ? 'column-reverse' : 'column'};
        flex-wrap: nowrap;
        margin: 0;
        position: relative;
        padding: 0;
      `}>
      <div css={css `
          height: ${isExpanded
            ? 3 * (LOGO_HEIGHT_DESKTOP + THUMBNAIL_SPACE)
            : 0}px;
          opacity: ${isExpanded ? 1 : 0};
          transition: height 0.3s cubic-bezier(0.16, 1, 0.3, 1) 0.1s,
            opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          overflow: hidden;
        `}>
        {items.map((item, index) => (<div key={`item-${index}`} css={css `
              margin-${reverse ? 'top' : 'bottom'}: ${THUMBNAIL_SPACE}px;
              position: relative;
            `}>
            {item}
          </div>))}
      </div>
      <ToggleButton onClick={onToggleExpand} style={{
            width: LOGO_HEIGHT / 2,
            height: LOGO_HEIGHT / 2,
        }} css={css `
          background: rgba(64, 64, 64, 0.5);
          cursor: pointer;
          border-radius: 50%;
          padding: 0 !important;
          transform: rotate(-${reverse === isExpanded ? 90 : 270}deg);
          transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        `}/>
    </div>);
};
export default Expandables;
